import { useEffect } from "react"
import { useRouter } from "@tanstack/react-router"

export function useSwNavigateBridge() {
  const router = useRouter()
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return
    const onMsg = (e: MessageEvent) => {
      if (e.data?.type === "navigate" && typeof e.data.link === "string") {
        router.navigate({ to: e.data.link })
      }
    }
    navigator.serviceWorker.addEventListener("message", onMsg)
    navigator.serviceWorker.ready.then((reg) => {
      reg.active?.postMessage({ type: "sw-ready" })
    })
    return () => navigator.serviceWorker.removeEventListener("message", onMsg)
  }, [router])
}
